import navSpawn from '../components/navSpawn';

export default {
  init() {
    // JavaScript to be fired on the team page
  },
  finalize() {

    /* Team Nav */
    let anchors = document.querySelectorAll('.anchor');
    anchors.forEach(function(a) {
      navSpawn(a);
    });
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('team-top').scrollIntoView({
          behavior: 'smooth',
        });
      });
    });

    $('#anchor-list.team-nav li:not(.current-nav-item) a').on('click', function(e){
      e.stopPropagation();
      var role = $(this).parent().attr('data-anchor-id');
      if (role != 'associates') {
        $('.the-team').hide();
        $('.the-team[data-anchor-id="' + role + '"]').show()
        $('#anchor-list li').removeClass('current-nav-item');
        $(this).parent().addClass('current-nav-item');
      } else {
        $('.the-team').show();
        $('#anchor-list li').removeClass('current-nav-item');
        $('#anchor-list li:first').addClass('current-nav-item');
      }
    })
    /* end Team Nav */

    $(window).on('scroll', function() {
      if ($('#anchor-list').length) {
        var scrollAmount = $(window).scrollTop(),
            windowHeight = $(window).height(),
            halfHeight = $(window).height() / 2,
            topOfHiddenDiv = $('#anchor-list').offset().top + 200;

        if (((scrollAmount + windowHeight) - halfHeight) >= topOfHiddenDiv) {
          $('#anchor-list').addClass('nav-focused');
          console.log($('.current-nav-item').length);
          if($('.current-nav-item').length < 1) {
            $('#anchor-list li:first').addClass('current-nav-item');
          }
          $('.anchor-nav').addClass('active');
        } else {
          $('#anchor-list').removeClass('nav-focused');
          $('.anchor-nav').removeClass('active');
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/team.js